import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=489fb112&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=489fb112&prod&lang=scss&scoped=true&"
import style1 from "./_id.vue?vue&type=style&index=1&id=489fb112&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489fb112",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/home/vsts/work/1/s/components/PageHeader.vue').default,Screening: require('/home/vsts/work/1/s/components/Screening.vue').default,AeqTimeline: require('/home/vsts/work/1/s/components/AeqTimeline.vue').default})
